import endpoints from '../endpoints'
import axios from 'axios'

const state = {
  content: {
    officeorder: {
      officeOrderId: false,
      type: false,
      hostId: null,
      hostName: '',
      clients: []
    },
    username: '',
    clipboardSuccess: false,
    shareSuccess: false,
    orderLink: '',
    payPalMe: ''
  }
}

const getters = {
  hasOfficeOrder: (state) => (hostId) => parseInt(state.content.officeorder.hostId) === parseInt(hostId),
  officeOrder: state => state.content.officeorder,
  officeOrderClients: state => state.content.officeorder.clients,
  officeOrderUsername: state => state.content.username,
  officeOrderLink: state => state.content.orderLink,
  officeOrderPayPalMe: state => state.content.payPalMe,
  isOfficeOrderMaster: state => (state.content.officeorder.type === 'master'),
  isOfficeOrderClient: state => (state.content.officeorder.type === 'client'),
  isOfficeOrderClipboardSuccess: state => state.content.clipboardSuccess,
  isOfficeOrderShareSuccess: state => state.content.shareSuccess
}

const actions = {
  setOfficeOrderHostId ({ state, commit }, payload) {
    axios.post(endpoints.isOfficeOrder, payload)
      .then(({data}) => {
        let officeOrderEnded = false

        // if the BE says the office order has ended but the FE was in client mode, alert the user that the office
        // order is over
        if (state.content.officeorder.type === 'client' && !data.officeOrderId) {
          officeOrderEnded = true
        }

        commit('setOfficeOrder', data)

        if (officeOrderEnded) {
          alert('Die Bürobestellung wurde beendet')
        }
      })
  },

  createOfficeOrder ({ dispatch, commit }, payload) {
    axios.post(endpoints.createOfficeOrder, payload)
      .then(({data}) => {
        commit('setOfficeOrder', data)
      })
  },

  inviteClients ({ state, commit, dispatch }) {
    const url = state.content.orderLink
    const subject = 'Einladung zur Gruppenbestellung bei ' + encodeURIComponent(state.content.officeorder.hostName)
    const body = 'Hey,%0a' +
              '%0a' +
              'wir bestellen gleich bei ' + encodeURIComponent(state.content.officeorder.hostName) + '%0a' +
              'Wenn du auch etwas möchtest, klicke bitte auf den folgenden Link:%0a' +
              url + '%0a' +
              '%0a' +
              'Sobald du alles im Warenkorb hast, klicke dort bitte auf "Bestellung abschliessen".%0a' +
              'Viele Grüße und guten Appetit!'

    if (navigator.share) {
      navigator.share({
        title: subject,
        text: decodeURI(body),
        url: url
      }).then(() => {
        commit('setShareSuccess', true)
      }).catch((e) => {
        commit('setShareSuccess', false)
      })
    } else {
      dispatch('copyUrlAndSendMail', {
        url: url,
        subject: subject,
        body: body
      })
    }
  },

  copyUrl ({commit}, payload) {
    try {
      navigator.clipboard.writeText(payload).then(() => {
        commit('setClipboardSuccess', true)
      }, function () {
        commit('setClipboardSuccess', false)
      })
    } catch (e) {
      console.log(e)
    }
  },

  copyUrlAndSendMail ({commit}, payload) {
    try {
      navigator.clipboard.writeText(payload.url).then(() => {
        commit('setClipboardSuccess', true)

        window.setTimeout(() => {
          commit('setClipboardSuccess', false)
        }, 10000)
      }, function () {
        commit('setClipboardSuccess', false)
      })
    } catch (e) {
      console.log(e)
    }

    window.location.href = 'mailto:?subject=' + payload.subject + '&body=' + payload.body
  },

  cancelOfficeOrderMaster ({ commit }, payload) {
    if (!window.confirm('Wenn du die Gruppenbestellung abbrichst, kann keiner der bereits eingeladenen Kollegen zu deiner Bestellung beitragen.')) return

    axios.post(endpoints.cancelOfficeOrderMaster, payload)
      .then(() => {
        commit('clearOfficeOrder')
      })
  },

  cancelOfficeOrderClient ({ state, commit }) {
    if (!window.confirm('Wenn du die Gruppenbestellung abbrichst, werden die Artikel wieder in deinen eigenen Warenkorb gelegt und du bestellst für dich selbst.')) return

    axios.post(endpoints.cancelOfficeOrderClient, {
      officeOrderId: state.content.officeorder.officeOrderId
    })
      .then(() => {
        commit('setOfficeOrder', {
          officeOrderId: false,
          type: false,
          hostId: null,
          hostName: ''
        })
      })
  },

  watchOfficeOrder ({ getters, state, dispatch }) {
    if (getters.isOfficeOrderMaster || getters.isOfficeOrderClient) {
      dispatch('setOfficeOrderHostId', {
        hostId: state.content.officeorder.hostId
      })
    }
  }
}

const mutations = {
  setOfficeOrder (state, officeOrder) {
    state.content.officeorder = officeOrder
    state.content.orderLink = window.location.protocol + '//' + window.location.host + '/mitbestellen/' + state.content.officeorder.officeOrderId + '/' + state.content.officeorder.officeOrderUid
  },

  clearOfficeOrder (state) {
    state.content.officeorder = {
      officeOrderId: false,
      type: false,
      hostId: null,
      hostName: ''
    }
    state.content.clipboardSuccess = false
  },

  setClipboardSuccess (state, success) {
    state.content.clipboardSuccess = success
  },

  setShareSuccess (state, success) {
    state.content.shareSuccess = success
  },

  setOfficeOrderUsername (state, value) {
    state.content.username = value
  },

  setOfficeOrderPayPalMe (state, value) {
    state.content.payPalMe = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/officeorder.js